import removeNote from './remove-note.action';

export default removeNote;
